import { createAction } from 'redux-actions';

// import { loadGoogleLibrary, loadFacebookLibrary } from 'util/external';

// export const loadGoogle = createAction('LOAD_LIB_GOOGLE', loadGoogleLibrary);

// export const loadFacebook = createAction('LOAD_LIB_FACEBOOK', loadFacebookLibrary);

export const resizeWindow = createAction('RESIZE_WINDOW', (width, height) => ({ width, height }));

export const scrollWindow = createAction('SCROLL_WINDOW', scrollY => () => ({ scrollY }));

export const visibleWindow = createAction('VISIBLE_WINDOW', visible => ({ visible }));

export const matchMedia = createAction('MATCH_MEDIA', media => ({ media }));

export const toggleNavi = createAction('NAVI_TOGGLE', toggle => ({ toggle }));

export const toggleLoading = createAction('LOAD_TOGGLE', toggle => ({ toggle }));

export const updateHomeActiveSection = createAction(
	'UPDATE_HOME_ACTIVE_SECTION',
	activeSection => ({ activeSection }),
);



// WEBPACK FOOTER //
// ./src/actions/global.js